module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.3d3a53586bd78d1069ae.svg";


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/assets/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = ../../../../../src/assets/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module chunks = styles